import { WORDPRESS_API } from "shared/constants/api";


export const remoteWyrzyskProject = {
  id: "remote-wyrzysk",

  title:
    "Zdalny Wyrzysk – kształcenie zawodowe w trakcie pandemii w Powiecie Pilskim",

  description:
    "Projekt wspierający prowadzenie kształcenia zawodowego w formie zdalnej w CKZiU w Wyrzysku.",

  projectNumber: "RPWP.08.03.01-30-0008/20",

  period: "16.11.2020 – 31.12.2020",

  value: "417 925,00 zł",

  funding: "355 236,25 zł",

  programme: [
    "Oś priorytetowa 8 „Edukacja”",
    "Działanie 8.3. Wzmocnienie oraz dostosowanie kształcenia i szkolenia zawodowego do potrzeb rynku pracy",
    "Poddziałanie 8.3.1. Kształcenie zawodowe młodzieży – tryb konkursowy oraz tryb nadzwyczajny w zakresie epidemii COVID-19"
  ],

  image: {
    src: `${WORDPRESS_API}/wp-content/uploads/2022/08/Belka-EFS_Samorzad_kolor-PL-1-1024x104.jpg`,
    alt: "Fundusze Europejskie i Samorząd Województwa Wielkopolskiego",
    maxWidth: "1024px"
  }
};


export const remoteWyrzyskGoal =
  "Głównym celem projektu było zapewnienie możliwości prowadzenia kształcenia zawodowego w formie zdalnej w Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku – Technikum w Wyrzysku oraz Branżowej Szkole I Stopnia w Wyrzysku – poprzez wyposażenie szkół w sprzęt niezbędny do prowadzenia edukacji w formie zdalnej.";


export const remoteWyrzyskScope = [
  "Zakup sprzętu do prowadzenia nauki w formie zdalnej dla Technikum w Wyrzysku.",
  "Zakup sprzętu do prowadzenia nauki w formie zdalnej dla Branżowej Szkoły I Stopnia w Wyrzysku.",
  "Łącznie w ramach projektu zaplanowano zakup 80 laptopów i 13 tabletów."
];


export const remoteWyrzyskEffects = [
  "Złagodzenie skutków epidemii COVID-19 poprzez udostępnienie uczniom i nauczycielom sprzętu niezbędnego do prowadzenia nauki zdalnej.",
  "Zapewnienie dostępu do sprzętu osobom, które nie posiadały odpowiednich komputerów lub których sprzęt nie spełniał wymagań aplikacji wykorzystywanych podczas nauki zdalnej.",
  "Pozostawienie zakupionego sprzętu w szkołach do dalszego wykorzystania podczas kształcenia stacjonarnego."
];


export const remoteWyrzyskTasks = [
  {
    id: "task-1",
    number: 1,
    title:
      "Doposażenie Technikum w Wyrzysku w sprzęt do nauki zdalnej",

    period: "16.11.2020 – 31.12.2020",

    location:
      "Powiat Pilski / Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    description:
      "W ramach zadania zaplanowano zakup sprzętu wraz z oprogramowaniem dla Technikum w Wyrzysku.",

    items: [
      "40 laptopów wraz z oprogramowaniem, w tym oprogramowaniem do nauki zdalnej",
      "13 tabletów wraz z oprogramowaniem, w tym oprogramowaniem do nauki zdalnej"
    ]
  },

  {
    id: "task-2",
    number: 2,
    title:
      "Doposażenie Branżowej Szkoły I Stopnia w Wyrzysku w sprzęt do nauki zdalnej",

    period: "16.11.2020 – 31.12.2020",

    location:
      "Powiat Pilski / Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",

    description:
      "W ramach zadania zaplanowano zakup sprzętu wraz z oprogramowaniem dla Branżowej Szkoły I Stopnia w Wyrzysku.",

    items: [
      "40 laptopów wraz z oprogramowaniem, w tym oprogramowaniem do nauki zdalnej"
    ]
  }
];


export const remoteWyrzyskGallery = [
  {
    id: "remote-1",
    src: `${WORDPRESS_API}/wp-content/uploads/2022/08/132111992_4744891928914070_6124618204884576517_n.jpg`,
    alt: "Sprzęt zakupiony w ramach projektu Zdalny Wyrzysk"
  },
  {
    id: "remote-2",
    src: `${WORDPRESS_API}/wp-content/uploads/2022/08/132252939_4744892142247382_2581796182585843748_n.jpg`,
    alt: "Realizacja projektu Zdalny Wyrzysk"
  },
  {
    id: "remote-3",
    src: `${WORDPRESS_API}/wp-content/uploads/2022/08/132258899_4744892798913983_4588860417483099479_n.jpg`,
    alt: "Sprzęt do nauki zdalnej w CKZiU w Wyrzysku"
  }
];